import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import API from 'api';
import Ad from 'models/business/Ad';
import MainForm from './MainForm';
// import ReviewForm from './ReviewForm';

// const Steps = {
//   Main: 'main',
//   Review: 'review',
// };

export default function SSCDashboard() {
  const [ad, setAd] = useState(new Ad());
  // const [step, setStep] = useState(Steps.Main);
  const [firstEdit, setFirstEdit] = useState(false);
  const location = useLocation();

  const fetchAssets = async (id) => {
    const result = await API.ad.getAdAssets(id);
    if (!result.error) {
      return result;
    }
    return [];
  };

  useEffect(() => {
    const newAd = new Ad(location.state?.ad);
    if (newAd.id) {
      fetchAssets(newAd.id).then((assets) => {
        newAd.injectAssets(assets);
        setAd(newAd);
      });
    }
    setFirstEdit(!!location.state?.firstEdit);
  }, [location]);

  return (
    <div>
      {/* {step === Steps.Main ? ( */}
      <MainForm
        ad={ad}
        onChangeAd={setAd}
        // onContinue={() => setStep(Steps.Review)}
        firstEdit={firstEdit}
      />
      {/* ) : (
        <ReviewForm ad={ad} onChangeAd={setAd} />
      )} */}
    </div>
  );
}
